import { render } from "./CIS-Featured-Article.vue?vue&type=template&id=45e0edfc&scoped=true"
import script from "./CIS-Featured-Article.vue?vue&type=script&lang=js"
export * from "./CIS-Featured-Article.vue?vue&type=script&lang=js"

import "./CIS-Featured-Article.vue?vue&type=style&index=0&id=45e0edfc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e0edfc"]])

export default __exports__